import { Component, ViewChild, SecurityContext, HostListener, OnDestroy, HostBinding, Input, ComponentFactoryResolver, EmbeddedViewRef, Injector, ApplicationRef, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

import { SlideshowService } from '../slideshow.service';
import { ApiService } from '../../shared/api.service';
import {PreviewImageDialog} from '../images/preview-image-dialog';
import { JoyrideService, JoyrideSteps } from '../../joyride/joyride.service';
import {Utils} from '../../utils';
import { UserService } from '../../shared/user.service';
import {UserSettingsService} from '../../shared/user-settings.service';
import { PreviewContentComponent } from './preview/content.component';
import { PreviewContentQuizComponent } from './preview/content-quiz.component';
import { fromEvent } from 'rxjs';

@Component({
    selector: 'preview-component',
    templateUrl: 'preview.component.html',
    styles: [`
        .mobile .device-wrap, .tablet .device-wrap {
            padding-right: var(--scrollbarPadding);
        }
        .mobile .device-wrap::-webkit-scrollbar, 
        .tablet .device-wrap::-webkit-scrollbar {
            width: var(--scrollbarWidth);
        }
        .mobile .device-wrap::-webkit-scrollbar-thumb, 
        .tablet .device-wrap::-webkit-scrollbar-thumb,
        .mobile .device-wrap::-webkit-scrollbar-track, 
        .tablet .device-wrap::-webkit-scrollbar-track {
            border-radius: var(--scrollbarRadius);
        }
    `]
})
export class PreviewComponent implements OnDestroy {
    isOpen = true;
    scrollbarWidth = 10;
    scrollbarPadding = 40;
    scrollbarRadius = 5;
    @HostBinding("attr.style")
    public get valueAsStyle(): any {
        return this.sanitizer.bypassSecurityTrustStyle(`
            --scrollbarWidth: ${this.scrollbarWidth}px; 
            --scrollbarPadding: ${this.scrollbarPadding}px;
            --scrollbarRadius: ${this.scrollbarRadius}px;
        `);
    }
    devices = [
        'desktop',
        'mobile',
        'tablet'
    ];
    selectedDevice = this.devices[0];
    pages = ['article', 'home'];
    selectedPage = this.pages[0];
    sites = [];
    selectedSite;
    working = false;
    previewUrl = '';
    previewWidth = 1200;
    previewContext;
    editButtons = [];
    editClasses = [];
    iframeZoom = 1;
    deviceZoom = 1;
    iframeMessageSubscription;
    loading = false;
    firstLoad = false;
    imageSizes = {
        thumbnail: {
            value: 'thumbnail',
            label: 'Thumbnail',
            fixed: true,
            width: 150,
            height: 150
        },
        medium: {
            value: 'medium',
            label: 'Medium',
            fixed: false,
            width: 480,
            height: 0
        },
        full: {
            value: 'full',
            label: 'Full',
            fixed: false,
            width: 1200,
            height: 0
        },
        feed_large: {
            value: 'feed_large',
            label: 'Feed Large',
            fixed: true,
            width: 600,
            height: 338
        },
        feed_medium: {
            value: 'feed_medium',
            label: 'Feed Medium',
            fixed: true,
            width: 320,
            height: 180
        },
        feed_small: {
            value: 'feed_small',
            label: 'Feed Small',
            fixed: true,
            width: 180,
            height: 101
        },
        feed_landscape: {
            value: 'feed_landscape',
            label: 'Feed Landscape',
            fixed: true,
            width: 1200,
            height: 675
        },
        feed_portrait: {
            value: 'feed_portrait',
            label: 'Feed Portrait',
            fixed: true,
            width: 600,
            height: 800
        },
        feed_square: {
            value: 'feed_square',
            label: 'Feed Square',
            fixed: true,
            width: 300,
            height: 300
        },
        feed_applenews: {
            value: 'feed_applenews',
            label: 'Feed - Apple News',
            fixed: true,
            width: 800,
            height: 800
        },
        'left-col/large': {
            value: 'left-col/large',
            label: 'Left Column Large',
            fixed: true,
            width: 620,
            height: 413
        },
        'sidebar/split': {
            value: 'sidebar/split',
            label: 'Sidebar Split',
            fixed: true,
            width: 150,
            height: 100
        },
    }
    optionsOpen = false;
    imagesOpen = false;
    featuredImageSubscription;
    contentComponentRef;
    contentComponentHostEl = document.createElement('div');
    disableDeviceOptions = false;
    disableSiteOptions = true;

    @Input('animationComplete') animationComplete;

    @ViewChild('iframeEl') iframeEl: ElementRef;
    @ViewChild('previewWrapEl') previewWrapEl: ElementRef;
    @ViewChild('deviceSkinEl') deviceSkinEl: ElementRef;
    @ViewChild('joyrideTemplate') joyrideTemplate: ElementRef;
    @ViewChild('articleEl', {read: ElementRef}) articleEl: ElementRef;

    joyrideName = 'didhomepreviewjoyride';
    joyrideSteps:JoyrideSteps = {
        step1: {
            name: 'step1',
            text: 'Welcome to the new preview tab! Would you like a tour?<br><br/>Restart the tour any time by clicking <span class="material-icons">help_outline</span> in the settings menu <span class="material-icons">settings_cell</span> (top right)',
            position: 'center',
            next: (e) => {
                this.selectedDevice = 'desktop';
                this.setDevice();
                this.selectedPage = this.pages[0];
                this.setPreview();
                this.optionsOpen = true;
                this.imagesOpen = false;
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        stepDevice: {
            name: 'stepDevice',
            title: 'Preview Device Options',
            text: 'Select a device to preview the article on a different device',
            next: (e) => {
                if( !this.selectedSite ) {
                    this.joyride.pause();
                    this.imagesOpen = true;
                    this.optionsOpen = false;
                }
                if( !this.slideshow.getFeaturedImage() ) {
                    this.joyride.pause();
                    this.imagesOpen = true;
                    this.optionsOpen = false;
                }
                if( !this.selectedSite || !this.slideshow.getFeaturedImage() ) {
                    return;
                }
                this.disableDeviceOptions = true;
                this.selectedDevice = 'desktop';
                this.setDevice();
                this.selectedPage = this.pages[1];
                this.setPreview();
                this.optionsOpen = true;
                this.imagesOpen = false;
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        stepNoSite: {
            name: 'stepNoSite',
            title: 'Select Site & Featured Image',
            text: 'Select a site on the meta tab and a featured image to continue',
            position: 'center',
            skip: true,
            next: (e) => {
                this.joyrideSteps.stepNoImage.skip = true;
                if( !this.slideshow.getFeaturedImage() ) {
                    this.joyrideSteps.stepNoImage.skip = false;
                    this.joyride.pause();
                    this.imagesOpen = true;
                    this.optionsOpen = false;
                    return;
                }
                this.disableDeviceOptions = true;
                this.selectedDevice = 'desktop';
                this.setDevice();
                this.selectedPage = this.pages[1];
                this.setPreview();
                this.optionsOpen = true;
                this.imagesOpen = false;
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        stepNoImage: {
            name: 'stepNoImage',
            title: 'Select Featured Image',
            text: 'Select a featured image to continue',
            skip: true,
            next: (e) => {
                this.disableDeviceOptions = true;
                this.selectedDevice = 'desktop';
                this.setDevice();
                this.selectedPage = this.pages[1];
                this.setPreview();
                this.optionsOpen = true;
                this.imagesOpen = false;
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        step2: {
            name: 'step2',
            title: 'Preview Page Options',
            text: 'We\'ve added a Home Page preview button. Yay!<br><br>The settings will be disabled until the tour is over',
            next: (e) => {
                this.optionsOpen = false;
                this.imagesOpen = false;
                if( this.editButtons.length > 1 ) {
                    const btn = this.editButtons[1];
                    this.editMouseOver(btn);
                }
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        step3: {
            name: 'step3',
            title: 'Hover to Highlight Same Size',
            text: 'Hover over an icon <span class="material-icons">create</span> to highlight all slots that use the same image size',
            next: (e) => {
                this.optionsOpen = false;
                this.imagesOpen = false;
                if( this.editButtons.length > 1 ) {
                    const btn = this.editButtons[1];
                    this.editMouseLeave(btn);
                }
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        step4: {
            name: 'step4',
            title: 'Click to Edit',
            text: 'Click an icon <span class="material-icons">create</span> to bring up the image details for the image size used in the slot',
            next: (e) => {
                this.optionsOpen = false;
                this.imagesOpen = true;
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        step5: {
            name: 'step5',
            title: 'Image Options',
            text: 'Set a new featured image to preview it on the home page',
            next: (e) => {
                this.optionsOpen = true;
                this.imagesOpen = false;
                this.disableSiteOptions = false;
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        stepSites: {
            name: 'stepSites',
            title: 'Preview Site Options',
            text: 'Select a new site to preview the article and home page on that site',
            position: 'top',
            next: (e) => {
                this.optionsOpen = false;
                this.imagesOpen = false;
            },
            done: (e) => {
                this.updateUserSettings();
            }
        },
        step6: {
            name: 'step6',
            text: 'The end. Happy previewing!',
            position: 'center',
            done: (e) => {
                this.updateUserSettings();
            }
        }
    };
    joyrideDoneSubscription;
    userSettingsSubscription;

    @HostListener('window:resize', ['$event'])
    resize(e) {
        this.setZoom();
        if( this.selectedPage == 'home' ) {
            this.setButtons();
        }
    }

    constructor(
        public slideshow: SlideshowService, 
        private api: ApiService, 
        private sanitizer: DomSanitizer, 
        private dialog: MatDialog, 
        public joyride: JoyrideService, 
        public utils: Utils,
        private userService: UserService,
        private resolver: ComponentFactoryResolver,
        private injector: Injector,
        private appRef: ApplicationRef,
        private userSetting: UserSettingsService,
        private zone: NgZone
    ) {
        if( slideshow.assignment ) {
            this.sites = slideshow.assignment.sites;
            if( this.sites.length ) {
                this.selectedSite = this.sites[0];
            }
        }
        this.userSettingsSubscription = this.userSetting.change.subscribe(settings => {
            this.setZoom();
            if( this.selectedPage == 'home' ) {
                this.setButtons();
            }
        });
        this.featuredImageSubscription = this.slideshow.featuredImageChange.subscribe(image => {
            if( this.selectedPage == 'home' ) {
                this.updateImages();
            }
            const slides = this.slideshow.slides;
            if( this.previewContext && this.selectedPage == 'article' && slides.length > 0 && this.slideshow.quiz ) {
                this.zone.runOutsideAngular(() => {
                    const src = image ? image.sizes.quiz.urlWithParams : '';
                    let img = this.previewContext.querySelector('quiz-image picture img');
                    if( img ) {
                        img.src = src;
                        return;
                    }
                    const picture = this.previewContext.querySelector('quiz-image picture');
                    if( !picture ) {
                        return;
                    }
                    img = document.createElement('img');
                    img.src = src;
                    picture.appendChild(img);
                });                
            }
            if( !image ) {
                this.joyrideSteps.stepNoImage.skip = false;
                this.joyride.pause();
            }
            if( !this.selectedSite ) {
                this.joyrideSteps.stepNoSite.skip = false;
                this.joyride.pause();
            }
            if( image && this.selectedSite ) {
                this.joyrideSteps.stepNoImage.skip = true;
                this.joyrideSteps.stepNoSite.skip = true;
                this.joyride.resume();
            }
        });
        this.joyrideDoneSubscription = this.joyride.end.subscribe(data => {
            this.optionsOpen = false;
            this.imagesOpen = false;
            if( this.editButtons.length > 1 ) {
                const btn = this.editButtons[1];
                this.editMouseOver(btn);
            }
            if( !this.firstLoad ) {
                this.setPreview();
            }
            this.joyrideDoneSubscription.unsubscribe();
        });
    }
    ngAfterViewInit() {
        if( !this.selectedSite ) {
            this.setContentHeight();
        }
        const user = this.api.getProp('user');
        const joyrideName = this.joyrideName;
        if( !user.settings[joyrideName] ) {
            this.runJoyride();
        } else {
            this.setPreview();
        }
    }
    joyrideTimeout;
    runJoyride() {
        if( this.animationComplete ) {
            clearTimeout(this.joyrideTimeout);
            this.optionsOpen = true;
            this.imagesOpen = false;
            this.joyrideSteps.stepNoSite.skip = true;
            if( !this.selectedSite ) {
                this.joyrideSteps.stepNoSite.skip = false;
            }
            this.joyrideSteps.stepNoImage.skip = true;
            if( !this.slideshow.getFeaturedImage() ) {
                this.optionsOpen = false;
                this.imagesOpen = true;
                this.joyrideSteps.stepNoImage.skip = false;
            }
            this.disableDeviceOptions = false;
            this.disableSiteOptions = true;
            this.joyride.start({
                order: Object.keys(this.joyrideSteps),
                scrollContainerRef: this.previewWrapEl
            });
            return;
        }
        this.joyrideTimeout = setTimeout(() => {
            this.runJoyride();
        }, 100);
    }
    updateUserSettings() {
        const setting = {};
        setting[this.joyrideName] = true;
        this.userService.updateMeta(setting);
    }
    optionChange() {
        this.setPreview();
    }
    setPreview() {
        if( !this.iframeEl ) {
            return;
        }
        this.loading = true;
        this.destroyContext();
        this.iframeEl.nativeElement.src = '';
        const featuredImage = this.slideshow.getFeaturedImage();
        let full = '', medium = '', thumbnail = '', alt = '';
        if( featuredImage ) {
            full = featuredImage.sizes.full.urlWithParams;
            medium = featuredImage.sizes.medium.urlWithParams;
            thumbnail = featuredImage.sizes.thumbnail.urlWithParams;
            alt = featuredImage.alt;
        }
        const url = this.api.buildQuery(this.api.getProp('url') + '/wp-admin/admin-ajax.php', {
            action: 'swarm_preview',
            blog_id: this.selectedSite ? this.selectedSite.blog_id : '',
            slides: this.slideshow.assignment.slides,
            quiz: this.slideshow.quiz,
            domain: this.selectedSite ? this.selectedSite.domain : '',
            category: this.selectedSite.categories.length ? this.selectedSite.categories[0].name : '',
            page: this.selectedPage,
            permalink: this.selectedSite ? this.selectedSite.permalink : '',
            full: encodeURIComponent(full),
            medium: encodeURIComponent(medium),
            thumbnail: encodeURIComponent(thumbnail),
            alt: alt,
            articleTitle: this.slideshow.assignment.articleTitle,
            v: new Date().getTime()
        });
        this.previewUrl = this.sanitizer.sanitize(SecurityContext.URL, url);
        if( !this.firstLoad ) {
            const firstLoadSubscription = fromEvent(this.iframeEl.nativeElement, 'load').subscribe(() => {
                this.firstLoad = true;
                firstLoadSubscription.unsubscribe();
            });
        }
        this.iframeEl.nativeElement.src = this.previewUrl;
    }
    setZoom() {
        const el = this.iframeEl ? this.iframeEl : this.articleEl;
        if( !el ) {
            return;
        }
        const iframeEl = el.nativeElement;
        const device = this.selectedDevice;
        let previewWidth = this.previewWidth + 17;
        const bounds = this.previewWrapEl.nativeElement.getBoundingClientRect();
        const maxWidth = bounds.width;
        const maxHeight = (bounds.height * .9) - 20;
        const deviceSkinEl = this.deviceSkinEl.nativeElement;
        const deviceHeight = deviceSkinEl.offsetHeight;
        let deviceZoom = 1;
        let iframeZoom = 1;
        if( maxWidth < previewWidth ) {
            iframeZoom = maxWidth / previewWidth;
        }
        iframeEl.style.transition = this.selectedDevice == 'desktop' ? 'none' : 'width .2s linear';
        iframeEl.style.width = maxWidth > previewWidth ? null : previewWidth + 'px';
        iframeEl.style.transform = 'scale(' + iframeZoom + ')';
        this.iframeZoom = iframeZoom;
        if( (device == 'mobile' || device == 'tablet') && maxHeight < deviceHeight ) {
            deviceZoom = maxHeight / deviceHeight;
        }
        const fromZoom = this.deviceZoom;
        const deviceZoomDistance = deviceZoom - fromZoom;
        const padding = this.selectedDevice == 'tablet' ? 50 : 40;
        const newWidth = (1 + (1 - deviceZoom)) * 10;
        const fromWidth = this.scrollbarWidth;
        const widthDistance = newWidth - fromWidth;
        this.scrollbarRadius = Math.ceil(Math.ceil(this.scrollbarWidth) / 2);
        const newPadding = padding - (this.scrollbarWidth - 10);
        const fromPadding = this.scrollbarPadding;
        const paddingDistance = newPadding - fromPadding;
        this.utils.animate({
            draw: (progress) => {
                const scale = fromZoom + (deviceZoomDistance * progress);
                deviceSkinEl.style.transform = 'scale(' + scale + ')';
                this.scrollbarPadding = fromPadding + (paddingDistance * progress);
                this.scrollbarWidth = fromWidth + (widthDistance * progress);
                if( progress == 1 ) {
                    this.deviceZoom = deviceZoom;
                    this.setContentHeight();
                }
            }
        });     
    }
    hideButtons(opacity) {
        const editButtons = this.editButtons;
        const transition = !opacity ? 'opacity .2s linear' : 'none';
        for(var i = 0; i < editButtons.length; i++) {
            const btn = editButtons[i];
            btn.styles.opacity = opacity;
            btn.styles.transition = transition;
        }
    }
    isCarouselItemOffscreen(el) {
        const bounds = el.getBoundingClientRect();
        const left = bounds.left < -5;
        const right = (bounds.right - 5) > this.previewWidth;
        return left || right;
    }
    isVisible(el) {
        if( el.classList.contains('wrap') && el.offsetHeight == 0 ) {
            return false;
        }
        if( 
            (
                el.classList.contains('carousel-slide') ||
                el.classList.contains('tns-item')
            ) && 
            this.isCarouselItemOffscreen(el) 
        ) {
            return false;
        }
        if( !el.parentElement ) {
            return true;
        }
        return this.isVisible(el.parentElement);
    }
    isContentOverlapping(img, bounds) {
        let box = img.parentElement.parentElement.parentElement.parentElement;
        if( !box.classList.contains('box') ) {
            return false;
        }
        let contentEl = box.querySelector('.content');
        if( !contentEl ) {
            return false;
        }
        const contentBounds = contentEl.getBoundingClientRect();
        const minTop = bounds.top + 50;
        if( contentBounds.top < minTop && contentBounds.left < bounds.right ) {
            return true;
        }
        return false;
    }
    btnTimeout;
    setButtons() {
        if( this.selectedPage != 'home' ) {
            clearTimeout(this.btnTimeout);
            return;
        }
        if( !this.previewContext ) {
            this.btnTimeout = setTimeout(() => {
                this.setButtons();
            }, 200);
            return;
        }
        clearTimeout(this.btnTimeout);
        this.editButtons = [];
        const images = this.previewContext.querySelectorAll('img[data-image-size]');
        const editClasses = ['edit-mobile', 'edit-tablet', 'edit-desktop'];
        const maxWidth = this.iframeEl.nativeElement.offsetWidth;
        let editSizes = {};
        let btnIndex = 0;
        for(var i = 0; i < images.length; i++) {
            const img = images[i];
            if( !this.isVisible(img) ) {
                continue;
            }
            const size = img.dataset.imageSize;
            editClasses.push('edit-' + size);
            editSizes[size] = size;
            let mobileSize:any = false;
            const mobileSource = img.parentElement.querySelector('source[data-mobile-size]');
            if( mobileSource ) {
                mobileSize = mobileSource.dataset.mobileSize;
                editClasses.push('edit-' + mobileSize);
                editSizes[mobileSize] = mobileSize;
                img.classList.add('item-has-mobile');
            }
            let tabletSize:any = false;
            const tabletSource = img.parentElement.querySelector('source[data-tablet-size]');
            if( tabletSource ) {
                tabletSize = tabletSource.dataset.tabletSize;
                editClasses.push('edit-' + tabletSize);
                editSizes[tabletSize] = tabletSize;
                img.classList.add('item-has-tablet');
            }
            const bounds = img.getBoundingClientRect();
            const top = (bounds.top * this.iframeZoom) + 10;
            let left = (bounds.right * this.iframeZoom) - 40;
            const right = bounds.right;
            if( right > maxWidth ) {
                left -= (right - maxWidth);
            }
            if( this.isContentOverlapping(img, bounds) ) {
                left = (bounds.left * this.iframeZoom) + 10;
            }
            this.editButtons.push({
                styles: {
                    top: Math.round(top) + 'px',
                    left: Math.round(left) + 'px',
                    transition: 'none'
                },
                size: size,
                mobileSize: mobileSize,
                tabletSize: tabletSize,
                displayWidth: img.width,
                displayHeight: img.height,
                index: btnIndex
            });
            btnIndex++;
        }
        this.editClasses = editClasses;
        this.setStyles(editSizes);
        this.hideButtons(1);
        this.loading = false;
    }
    setStyles(sizes) {
        if( !this.previewContext ) {
            return;
        }
        this.zone.runOutsideAngular(() => {
            let styles = [];
            const values = Object.keys(sizes);
            const len = values.length;
            let i = 0;
            const desktopClass = '.edit-desktop';
            const tabletClass = '.edit-tablet';
            const notTabletSelector = ':not(.item-has-tablet)';
            const mobileClass = '.edit-mobile';
            const notMobileSelector = ':not(.item-has-mobile)';
            for(i; i < len; i++) {
                const size = values[i];
                const sizeClass = '.edit-' + size.replace('\/', '\\/');
                const imgSeletor = ' img[data-image-size="' + size + '"]';
                const tabletSourceSelector = ' source[data-tablet-size="' + size + '"] ~ img';
                const mobileSourceSelector = ' source[data-mobile-size="' + size + '"] ~ img';
                styles.push(...[
                    sizeClass + desktopClass + imgSeletor,
                    sizeClass + tabletClass + tabletSourceSelector, // tablet source
                    sizeClass + tabletClass + tabletSourceSelector + notMobileSelector, // tablet source with no mobile source
                    sizeClass + tabletClass + imgSeletor + notTabletSelector, // img with no tablet source
                    sizeClass + mobileClass + mobileSourceSelector, // mobile source
                    sizeClass + mobileClass + tabletSourceSelector + notMobileSelector, // tablet source with no mobile source
                    sizeClass + mobileClass + imgSeletor + notTabletSelector + notMobileSelector // img with no tablet or mobile source
                ]);
            }
            const styleContent = styles.join(',') + ' { opacity: .6 }';
            
            let styleEl = this.previewContext.getElementById('preview-styles');
            if( !styleEl ) {
                styleEl = document.createElement('style');
                styleEl.type = 'text/css';
                styleEl.id = 'preview-styles';
                const headEl = this.previewContext.querySelector('head');
                headEl.appendChild(styleEl);
            }
            styleEl.innerHTML = styleContent;
        });
    }
    setContentHeight() {
        if( !this.articleEl ) {
            return;
        }
        this.zone.runOutsideAngular(() => {
            const articleEl = this.articleEl.nativeElement;
            const deviceHeight = this.deviceSkinEl.nativeElement.offsetHeight;
            articleEl.style.minHeight = deviceHeight == 0 ? '100%' : deviceHeight + 'px';
            articleEl.style.transformOrigin = 'top left';
        });        
    }
    setDevice() {
        this.hideButtons(0);
        let width = 1200;
        switch(this.selectedDevice) {
            case 'tablet':
                width = 768;
                break;
            case 'mobile':
                width = 375;
                break;
            default:
                break;
        }
        this.previewWidth = width;
        setTimeout(() => {
            this.setZoom();
        }, 0);
    }
    getEditSize(btn) {
        let size = btn.size;
        if( btn.tabletSize && (this.selectedDevice == 'tablet' || this.selectedDevice == 'mobile') ) {
            size = btn.tabletSize;
        }
        if( btn.mobileSize && this.selectedDevice == 'mobile' ) {
            size = btn.mobileSize;
        }
        return size;
    }
    editMouseOver(btn) {
        if( !this.previewContext ) {
            return;
        }
        let size = this.getEditSize(btn); 
        let editClasses = ['edit-' + size, 'edit-' + this.selectedDevice];
        this.previewContext.body.classList.add(...editClasses);
    }
    editMouseLeave(e) {
        if( !this.previewContext ) {
            return;
        }
        this.previewContext.body.classList.remove(...this.editClasses);
    }
    updateImages() {
        if( !this.previewContext ) {
            return;
        }
        const featuredImage = this.slideshow.getFeaturedImage();
        if( !featuredImage ) {
            return;
        }
        this.zone.runOutsideAngular(() => {
            const images = this.previewContext.querySelectorAll('img[data-image-size]');
            const sizes = this.imageSizes;
            for(var i = 0; i < images.length; i++) {
                const img = images[i];
                const size = img.dataset.imageSize;
                if( !featuredImage.sizes[size] ) {
                    featuredImage.sizes[size] = {
                        width: sizes[size].width,
                        height: sizes[size].height,
                        urlWithParams: featuredImage.url + featuredImage.buildHttpParams(sizes[size]),
                        crop: {
                            width: sizes[size].width,
                            height: sizes[size].height
                        }
                    }
                }
                img.src = featuredImage.sizes[size].urlWithParams;
                const mobileSource = img.parentElement.querySelector('source[data-mobile-size]');
                if( mobileSource ) {
                    const mobileSize = mobileSource.dataset.mobileSize;
                    if( !featuredImage.sizes[mobileSize] ) {
                        featuredImage.sizes[mobileSize] = {
                            width: sizes[mobileSize].width,
                            height: sizes[mobileSize].height,
                            urlWithParams: featuredImage.url + featuredImage.buildHttpParams(sizes[mobileSize]),
                            crop: {
                                width: sizes[mobileSize].width,
                                height: sizes[mobileSize].height
                            }
                        }
                    }
                    mobileSource.srcset = featuredImage.sizes[mobileSize].urlWithParams;
                }
                const tabletSource = img.parentElement.querySelector('source[data-tablet-size]');
                if( tabletSource ) {
                    const tabletSize = tabletSource.dataset.tabletSize;
                    if( !featuredImage.sizes[tabletSize] ) {
                        featuredImage.sizes[tabletSize] = {
                            width: sizes[tabletSize].width,
                            height: sizes[tabletSize].height,
                            urlWithParams: featuredImage.url + featuredImage.buildHttpParams(sizes[tabletSize]),
                            crop: {
                                width: sizes[tabletSize].width,
                                height: sizes[tabletSize].height
                            }
                        }
                    }
                    tabletSource.srcset = featuredImage.sizes[tabletSize].urlWithParams;
                }
            }
        });
    }
    editClick(btn) {
        const size = this.getEditSize(btn);
        const dialog = this.dialog.open(PreviewImageDialog, {
            panelClass: 'preview-image',
            data: {
                image: this.slideshow.getFeaturedImage(),
                canEdit: !this.slideshow.locked,
                size: this.imageSizes[size],
                displayWidth: btn.displayWidth,
                displayHeight: btn.displayHeight
            }
        });
        dialog.afterClosed().subscribe(data => {
            this.updateImages();
        });
    }
    setCategory() {
        const cat = this.selectedSite.categories.length ? this.selectedSite.categories[0] : false;
        if( !cat ) {
            return;
        }
        const cats = this.previewContext.querySelectorAll('.box .cat');
        for(var i = 0; i < cats.length; i++) {
            cats[i].innerHTML = cat.name;
        }
    }
    setTitle() {
        const title = this.slideshow.assignment.articleTitle ? this.slideshow.assignment.articleTitle : false;
        if( !title ) {
            return;
        }
        if( this.selectedPage == 'article' ) {
            const h1 = this.previewContext.querySelector('h1');
            if( h1 ) {
                h1.innerHTML = title;
            }
            return;
        }
        let titles = this.previewContext.querySelectorAll('.box .title, .tns-item .title, .post .content .entry-title span');
        for(var i = 0; i < titles.length; i++) {
            titles[i].innerHTML = title;
        }
    }
    getIntroText() {
        if( this.slideshow.slides.length == 0 ) {
            return;
        }
        const div = document.createElement('div');
        const html = this.slideshow.slides[0].content.map(item => item.text).join(' ');
        div.innerHTML = html;
        return div.textContent;
    }
    trimExcerpt(excerpt = '', wordCount = 37) {
        if( !excerpt ) {
            return '';
        }
        const words = excerpt.split(' ');
        if( words.length <= wordCount ) {
            return excerpt;
        }
        return words.slice(0, wordCount).join(' ') + '&hellip;';
    }
    setExcerpt() {
        if( !this.previewContext || this.selectedPage != 'home' ) {
            return;
        }
        const exerpt = this.getIntroText();
        let exerpts = this.previewContext.querySelectorAll('.box .excerpt');
        for(var i = 0; i < exerpts.length; i++) {
            let el = exerpts[i];
            if( el.firstChild && el.firstChild.tagName === 'P' ) {
                el = el.firstChild;
            }
            const wordCount = el.textContent.split(' ').length;
            el.innerHTML = this.trimExcerpt(exerpt, wordCount);
        }
    }
    getFactory() {
        if( this.slideshow.quiz ) {
            return this.resolver.resolveComponentFactory(PreviewContentQuizComponent);
        }
        return this.resolver.resolveComponentFactory(PreviewContentComponent);
    }
    destroyContent() {
        const component = this.contentComponentRef;
        if( component ) {
            component.destroy();
            this.appRef.detachView(component.hostView);
        }
        this.contentComponentHostEl.innerHTML = '';
    }
    getContentHtml() {
        if( this.contentComponentRef ) {
            this.destroyContent();
        }
        let component = this.contentComponentRef;
        const hostEl = this.contentComponentHostEl;
        const factory = this.getFactory();
        component = factory.create(this.injector);
        const componentLoadedSubscription = component.instance.loaded.subscribe(() => {
            this.contentLoaded.emit(hostEl.innerHTML);
            componentLoadedSubscription.unsubscribe();
        });
        this.appRef.attachView(component.hostView);
        hostEl.appendChild((component.hostView as EmbeddedViewRef<any>).rootNodes[0]);
        this.contentComponentRef = component;
    }
    contentLoaded = new EventEmitter();
    setInnerEntryContent() {
        if( !this.previewContext || this.selectedPage != 'article' ) {
            return;
        }
        const previewContentEl = this.previewContext.querySelector('.inner-entry-content');
        if( !previewContentEl ) {
            this.loading = false;
            return;
        }
        const contentLoadedSubscription = this.contentLoaded.subscribe(contentHtml => {
            const previewContentHtml = previewContentEl.html;
            if( previewContentHtml !== contentHtml ) {
                previewContentEl.innerHTML = contentHtml;
            }
            this.loading = false;
            contentLoadedSubscription.unsubscribe();
        });
        this.getContentHtml();
    }
    setContent() {
        if( !this.previewContext ) {
            return;
        }
        this.setCategory();
        this.setTitle();
        this.setExcerpt();
        this.setInnerEntryContent();
    }
    iframeLoaded() {
        this.previewContext = this.iframeEl.nativeElement.contentWindow.document;
        this.updateImages();
        this.setContent();
        this.setZoom();
    }
    iframeResize(e) {
        this.setButtons();
        if( this.selectedPage != 'home' ) {
            this.loading = false;
        }
    }
    toggle(prop) {
        this[prop] = !this[prop];
        if( prop == 'imagesOpen' ) {
            this.optionsOpen = false;
        }
        if( prop == 'optionsOpen' ) {
            this.imagesOpen = false;
        }
    }
    destroyContext() {
        this.editButtons = [];
        this.previewContext = null;
        clearTimeout(this.btnTimeout);
    }
    ngOnDestroy() {
        this.destroyContext();
        this.destroyContent();
        this.joyride.destroy();
        if( this.joyrideDoneSubscription ) {
            this.joyrideDoneSubscription.unsubscribe();
        }
        if( this.userSettingsSubscription ) {
            this.userSettingsSubscription.unsubscribe();
        }
        if( this.featuredImageSubscription ) {
            this.featuredImageSubscription.unsubscribe();
        }
    }
}